module.exports = __webpack_public_path__ + "img/pr-10.eef8c5e4.png";